export default __webpack_public_path__ + "static/media/profilePhoto.ab95481d.svg";